import { Settings, GraduationCap, Rocket, TrendingUp } from "lucide-react";
import DemoCTA from "./DemoCTA";
import { useSectionView } from "@/hooks/use-section-view";

const steps = [
  {
    icon: Settings,
    week: "Semana 1-2",
    title: "Configuração e Migração",
    description: "Importação de dados, configuração inicial e personalização da plataforma para seu negócio.",
  },
  {
    icon: GraduationCap,
    week: "Semana 3",
    title: "Treinamento e Onboarding",
    description: "Capacitação completa da equipe com materiais práticos e suporte dedicado.",
  },
  {
    icon: Rocket,
    week: "Semana 4",
    title: "Go-Live com Piloto",
    description: "Lançamento controlado com grupo piloto para validação e ajustes finos.",
  },
  {
    icon: TrendingUp,
    week: "Semana 5-6",
    title: "Expansão e Otimização",
    description: "Rollout completo para toda organização com otimização contínua baseada em dados.",
  },
];

const ImplementationSection = () => {
  const sectionRef = useSectionView<HTMLElement>("implementation");
  return (
    <section ref={sectionRef} className="py-20 lg:py-32 bg-gradient-to-br from-primary/5 to-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
            Implementação Rápida,{" "}
            <span className="text-primary">Resultados Imediatos</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Do primeiro chamado migrado ao time inteiro usando, em 4 a 6 semanas
          </p>
        </div>

        <div className="relative max-w-6xl mx-auto">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-primary/20 via-primary to-primary/20 -translate-y-1/2" />
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <div
                  key={index}
                  className="relative animate-scale-in"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <div className="bg-card rounded-2xl border border-border hover:shadow-card transition-all duration-300 p-6 relative z-10">
                    <div className="w-14 h-14 rounded-xl bg-primary flex items-center justify-center mb-4 mx-auto lg:mx-0">
                      <Icon className="w-7 h-7 text-primary-foreground" />
                    </div>
                    <div className="text-sm font-semibold text-primary mb-2">{step.week}</div>
                    <h3 className="text-xl font-bold mb-3">{step.title}</h3>
                    <p className="text-muted-foreground leading-relaxed text-sm">
                      {step.description}
                    </p>
                  </div>
                  
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-8 rounded-full bg-primary z-20 -translate-y-1/2">
                    <div className="absolute inset-2 rounded-full bg-background" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="mt-12 animate-fade-in">
          <DemoCTA location="implementation" />
        </div>
      </div>
    </section>
  );
};

export default ImplementationSection;
